import { Box, Button, FormHelperText } from "@mui/material";
import React from "react";
import { TextInput } from "./TextInput";

interface EmailFieldProps {
  email: string | null;
  onVerifyEmail: () => void;
  error?: string | JSX.Element
}

export const EmailField: React.FC<EmailFieldProps> = ({ email, onVerifyEmail, error }) => {
  return (
    <Box>
      {email ? (
        <TextInput
          label="Verify Email Address"
          value={email}
          readOnly={true}
          required={true}
          error={error}
        />
      ) : (
        <Button
          variant="contained"
          color="primary"
          onClick={onVerifyEmail}
          fullWidth
        >
          Verify Email Address
        </Button>
      )}
      {error && <FormHelperText
        component={'div'}
        error={!!error}
      >
        {error}
      </FormHelperText>}
    </Box>
  );
};
